import { usesClaudeTeam, type AiEngine } from "@/lib/ai-engine";

/**
 * Where a link into Content Studio should land.
 *
 * Gemini workspaces keep the original studio and its tabs. Claude-team workspaces (claude_worker and hybrid) get the
 * simple studio, which has no "playbook", "library" filter, "pages" or "videos" tab, so each old destination maps to
 * the closest new screen instead of silently falling back to Create:
 *
 *   review  : "something is waiting for approval"  -> Needs your review   (gemini: Posting Schedule, where "approve all" lives)
 *   pending : the old Library "pending" filter      -> Needs your review   (gemini: Library filtered to pending approval)
 *   pages   : Page Builder (optionally ?editPage=)  -> Ideas & requests    (gemini: Pages tab). It offers the advanced tool from there.
 *   videos  : Video Studio (script / brief params)  -> Ideas & requests    (gemini: Video Studio tab)
 */
export type StudioTarget = "review" | "pending" | "pages" | "videos";

export function studioHref(engine: AiEngine, target: StudioTarget, params: Record<string, string> = {}): string {
  const q = new URLSearchParams();
  if (usesClaudeTeam(engine)) {
    if (target === "review" || target === "pending") {
      q.set("tab", "review");
    } else {
      q.set("tab", "ideas");
      q.set("tool", target);
      for (const [k, v] of Object.entries(params)) q.set(k, v);
    }
    return `/content?${q.toString()}`;
  }
  switch (target) {
    case "review":
      q.set("tab", "playbook");
      break;
    case "pending":
      q.set("tab", "library");
      q.set("approvalStatus", "pending_approval");
      break;
    default:
      q.set("tab", target);
      for (const [k, v] of Object.entries(params)) q.set(k, v);
  }
  return `/content?${q.toString()}`;
}
